import { useEffect as s } from "react";
const d = (r, n, o = []) => {
  s(() => {
    const e = (t) => {
      t.key === r && n(t);
    };
    return window.addEventListener("storage", e), () => window.removeEventListener("storage", e);
  }, o);
};
export {
  d as default
};
//# sourceMappingURL=useStorageEvent.js.map
